var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "task-modal" } }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.eventModalData.summary,
          expression: "eventModalData.summary",
        },
      ],
      staticClass: "event-input",
      attrs: { placeholder: _vm.$t("calendar.title") },
      domProps: { value: _vm.eventModalData.summary },
      on: {
        input: function ($event) {
          if ($event.target.composing) {
            return
          }
          _vm.$set(_vm.eventModalData, "summary", $event.target.value)
        },
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "info" },
      [
        _c("span", { staticClass: "material-icons single" }, [
          _vm._v("access_time"),
        ]),
        _vm._v(" "),
        _c("a-date-picker", {
          staticClass: "single",
          attrs: { format: _vm.customFormat },
          model: {
            value: _vm.eventModalData.startDate,
            callback: function ($$v) {
              _vm.$set(_vm.eventModalData, "startDate", $$v)
            },
            expression: "eventModalData.startDate",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _c("a-time-picker", {
              staticClass: "single",
              attrs: { format: "HH:mm" },
              model: {
                value: _vm.eventModalData.startTime,
                callback: function ($$v) {
                  _vm.$set(_vm.eventModalData, "startTime", $$v)
                },
                expression: "eventModalData.startTime",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "info" },
      [
        _c(
          "a-checkbox",
          {
            staticStyle: { width: "100px" },
            model: {
              value: _vm.eventModalData.isAllDay,
              callback: function ($$v) {
                _vm.$set(_vm.eventModalData, "isAllDay", $$v)
              },
              expression: "eventModalData.isAllDay",
            },
          },
          [_vm._v(_vm._s(_vm.$t("calendar.allDay")))]
        ),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "100%" },
            attrs: { "show-search": "" },
            model: {
              value: _vm.eventModalData.repeat,
              callback: function ($$v) {
                _vm.$set(_vm.eventModalData, "repeat", $$v)
              },
              expression: "eventModalData.repeat",
            },
          },
          _vm._l(_vm.repeatTimes, function (repeatTime, index) {
            return _c(
              "a-select-option",
              { key: index, attrs: { value: repeatTime.value } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(repeatTime.label) +
                    "\n            "
                ),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "info" },
      [
        _c("span", { staticClass: "material-icons" }, [_vm._v("subject")]),
        _vm._v(" "),
        _c("a-input", {
          staticClass: "description",
          attrs: { placeholder: _vm.$t("message.description") },
          model: {
            value: _vm.eventModalData.description,
            callback: function ($$v) {
              _vm.$set(_vm.eventModalData, "description", $$v)
            },
            expression: "eventModalData.description",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "footer-action" }, [
      Object.keys(this.eventDetail).length > 0
        ? _c(
            "span",
            {
              staticClass: "btn delete",
              on: {
                click: function ($event) {
                  return _vm.deleteEvent()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("message.delete")))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "btn",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("calendar.cancel")))]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "btn",
          on: {
            click: function ($event) {
              return _vm.editOrCreateEvent()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("calendar.save")))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }